import React from 'react';

import { Box, Link } from '@mui/material';
import ResMedLogo from 'ui_patient/components/ResMedLogo';
import { useTranslation } from 'react-i18next';
import MaskSelectorToolStyles from 'ui_patient/pages/MaskSelectorTool/MaskSelectorToolStyles';
import { versionNumber } from 'ui-common/AppSettings';
const REGIONS = {
  US: {
    privacyUrl: process.env.REACT_APP_PRIVACY_POLICY_URL,
    // supportUrl: process.env.REACT_APP_SUPPORT_URL,
  },
  AU: {
    privacyUrl: process.env.REACT_APP_PRIVACY_POLICY_URL,
    // supportUrl: process.env.REACT_APP_SUPPORT_URL,
  },
}
const Footer = () => {
  const { t } = useTranslation('pages.MaskSelectorTool.Footer');

  // Localization Strings
  const copyrightMessage = t('copyrightMessage', {
    year: new Date().getFullYear(),
  });
  const privacyPolicyLink = t('privacyPolicyLink');
  const supportLink = t('supportLink');

  const { classes } = MaskSelectorToolStyles();

  return (
    <Box
      bgcolor="common.black"
      color="common.white"
      minHeight="76px"
      className={classes.headerFooterContainer}
    >
      <Box className={classes.footerContent}>
        <Box>
          <ResMedLogo height="44px" width="59px" />
        </Box>
        <Box ml={2} fontSize={12}>
          <Box mb={1}>
            {/* MaskSelector {versionNumber()} {copyrightMessage} */}
            SelfieCollect {copyrightMessage}
          </Box>
          <Box display="flex" color="grey.500">
            <Link href={REGIONS[process.env.REACT_APP_BUILD_REGION].privacyUrl} target="_blank" color="inherit">
              {privacyPolicyLink}
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
